function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Checkbox } from '@signicat/designi/components/inputs';
import { Icon } from '@signicat/designi/components/icons';
import { CustomPagination } from '@signicat/designi/components/pagination';
import { Tooltip } from '@signicat/designi/components/overlays';
import { getContacts } from "../../store/actions/contacts";
import { PAGE_SIZE } from "../../scripts/constants";
import t from "../../scripts/i18n";
import LoadingOverlay from "../common/LoadingOverlay";
import "../../styling/components/contacts/ContactsTable.css";

var ContactsTable = function ContactsTable(props) {
  var match = props.match,
      getContactsUrl = props.getContactsUrl,
      listId = props.listId;
  var id = match && match.params && match.params.id ? match.params.id : null;
  var dispatch = useDispatch();
  var history = useHistory();
  var state = useSelector(function (state) {
    return state.contacts;
  });
  var currentUserId = useSelector(function (state) {
    return state.app.userId;
  });
  var tableState = state.tableState;
  var contactList = state.data;
  var list = listId ? useSelector(function (state) {
    return state.contactLists.lists.find(function (x) {
      return x.id === listId;
    });
  }) : null;
  var selectedContacts = state.selectedContacts || [];
  var selectedContactsIds = selectedContacts.map(function (c) {
    return c.id;
  });

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      toggleAll = _useState4[0],
      setToggleAll = _useState4[1];

  var getFirstLetter = function getFirstLetter(contact) {
    var sameFirstLetterContacts = contactList.filter(function (c) {
      return c.firstName[0] === contact.firstName[0];
    });
    return contact.id === sameFirstLetterContacts[0].id ? contact.firstName[0] : '';
  };

  var handleToggleAll = function handleToggleAll(_ref) {
    var checked = _ref.target.checked;
    setToggleAll(checked);
    dispatch({
      type: 'SELECT_CONTACTS',
      value: checked
    });
  };

  var selectContact = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(contact) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return dispatch({
                type: 'SELECT_CONTACT',
                contact: contact
              });

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function selectContact(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var sortList = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(orderBy) {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              dispatch({
                type: 'SET_TABLE_STATE',
                tableState: _objectSpread(_objectSpread({}, tableState), {}, {
                  orderBy: orderBy,
                  orderByDesc: tableState.orderBy === orderBy ? !tableState.orderByDesc : false
                })
              });

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function sortList(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  var getContactItem = function getContactItem(contact, i) {
    return /*#__PURE__*/React.createElement("div", {
      className: "item-container",
      key: i
    }, /*#__PURE__*/React.createElement("span", {
      className: "first-letter"
    }, getFirstLetter(contact)), /*#__PURE__*/React.createElement("div", {
      className: "item ".concat(selectedContactsIds.includes(contact.id) ? 'selected' : '')
    }, /*#__PURE__*/React.createElement("div", {
      className: "checkbox"
    }, /*#__PURE__*/React.createElement(Checkbox, {
      checked: selectedContactsIds.includes(contact.id) || false,
      onChange: function onChange(e) {
        return selectContact(contact);
      }
    })), /*#__PURE__*/React.createElement(Tooltip, {
      anchor: /*#__PURE__*/React.createElement("span", {
        className: "name",
        onClick: function onClick() {
          return contact.portalUserId === currentUserId && history.push("/contacts/edit/".concat(contact.id));
        },
        style: {
          cursor: contact.portalUserId === currentUserId ? 'pointer' : 'default'
        }
      }, contact.firstName + ' ' + contact.lastName),
      arrow: true
    }, contact.firstName + ' ' + contact.lastName), contact.email ? /*#__PURE__*/React.createElement(Tooltip, {
      anchor: /*#__PURE__*/React.createElement("span", null, contact.email),
      arrow: true
    }, contact.email) : /*#__PURE__*/React.createElement("span", null, t('contact_list_no_email'), " "), /*#__PURE__*/React.createElement("span", null, contact.mobileNumber ? contact.mobileNumber.prefix + contact.mobileNumber.number : t('contact_list_no_phone')), contact.companyName && /*#__PURE__*/React.createElement(Tooltip, {
      anchor: /*#__PURE__*/React.createElement("span", null, contact.companyName),
      arrow: true
    }, contact.companyName)));
  };

  var getSortHeader = function getSortHeader(value, label) {
    return /*#__PURE__*/React.createElement("span", {
      className: "sort",
      onClick: function onClick() {
        return sortList(value);
      }
    }, label, tableState.orderBy === value && /*#__PURE__*/React.createElement(Icon, {
      name: tableState.orderByDesc ? 'descending' : 'ascending'
    }));
  };

  var handleChangePage = function handleChangePage(e) {
    dispatch({
      type: 'SET_TABLE_STATE',
      tableState: _objectSpread(_objectSpread({}, tableState), {}, {
        currentPage: e
      })
    });
  };

  useEffect(function () {
    setToggleAll(!contactList.some(function (c) {
      return !selectedContactsIds.includes(c.id);
    }));
  }, [contactList, selectedContactsIds]);
  useEffect(function () {
    dispatch({
      type: 'DESELECT_CONTACTS'
    });
  }, [getContactsUrl]);
  useEffect(function () {
    return function () {
      handleChangePage(1);
    };
  }, []);
  useEffect(function () {
    var updateList = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (selectedContacts.length) setToggleAll(false);
                _context3.next = 3;
                return dispatch({
                  type: 'SELECT_CONTACTS',
                  value: false
                });

              case 3:
                setLoading(true);
                _context3.next = 6;
                return dispatch(getContacts(_objectSpread(_objectSpread({}, tableState), {}, {
                  currentPage: 1
                }), getContactsUrl));

              case 6:
                setLoading(false);

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function updateList() {
        return _ref4.apply(this, arguments);
      };
    }();

    if (list) {
      // only on load
      updateList();
    }
  }, [list]);
  useEffect(function () {
    var updateList = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                setLoading(true);
                _context4.next = 3;
                return dispatch(getContacts(tableState, getContactsUrl));

              case 3:
                setLoading(false);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function updateList() {
        return _ref5.apply(this, arguments);
      };
    }();

    updateList();
  }, [tableState, getContactsUrl]);
  return /*#__PURE__*/React.createElement("div", {
    className: "contacts-table"
  }, loading && /*#__PURE__*/React.createElement(LoadingOverlay, {
    background: 'gray'
  }), /*#__PURE__*/React.createElement("div", {
    className: "item-container header"
  }, /*#__PURE__*/React.createElement("span", {
    className: "first-letter"
  }, "Z"), /*#__PURE__*/React.createElement("div", {
    className: "item"
  }, /*#__PURE__*/React.createElement("div", {
    className: "checkbox"
  }, /*#__PURE__*/React.createElement(Checkbox, {
    checked: toggleAll,
    onChange: handleToggleAll
  })), getSortHeader(0, t('contact_list_name')), getSortHeader(2, t('contact_list_email')), /*#__PURE__*/React.createElement("span", null, t('contact_list_phone')), getSortHeader(4, t('contact_list_work')))), contactList.map(function (contact, i) {
    return getContactItem(contact, i);
  }), /*#__PURE__*/React.createElement(CustomPagination, {
    disabled: loading,
    currentPage: tableState.currentPage,
    totalPages: Math.ceil(state.total / PAGE_SIZE),
    totalItems: state.total,
    currentPageItems: state.count,
    renderShowingString: function renderShowingString(currentPageCount, totalCount) {
      return t('contact_list_pagination', {
        currentPageCount: currentPageCount,
        totalCount: totalCount
      });
    },
    setCurrentPage: handleChangePage
  }));
};

export default ContactsTable;